"use client";

import { useEffect, useState } from "react";
import { formatReceivedAt, formatSentAt } from "@/lib/inbox/format-time";

/**
 * A time in the viewer's own time zone, as Gmail shows it. The server
 * formats in its own zone (UTC in production), so its text is only shown
 * until the page runs in the browser - rendering the local time straight
 * away would not match the server's HTML.
 */
export function LocalTime({
  iso,
  fallback,
  kind,
}: {
  /** The exact time; without it the fallback is shown. */
  iso?: string;
  /** The server's text for the same time. */
  fallback: string;
  /** "list": the thread list's shorthand; "message": a message header. */
  kind: "list" | "message";
}) {
  const [text, setText] = useState(fallback);

  useEffect(() => {
    if (!iso) {
      setText(fallback);
      return;
    }
    const date = new Date(iso);
    setText(kind === "list" ? formatReceivedAt(date) : formatSentAt(date));
  }, [iso, fallback, kind]);

  return (
    <time dateTime={iso} title={iso ? new Date(iso).toString() : undefined}>
      {text}
    </time>
  );
}
